import { z } from "zod";

export const ErrorResponse = z.object({
  errors: z
    .object({
      field: z.string(),
      message: z.string().array(),
    })
    .array(),
});
export type ErrorResponse = z.infer<typeof ErrorResponse>;
